module.exports = __webpack_public_path__ + "media/evolve/assets/icons/atlas/order-meal-2bff2bd5f22ba12277cbaea7e3acfd8c.svg";